import React from 'react';
import ClubhouseHeader from './ClubhouseHeader';
import ClubhouseBottomNav from './ClubhouseBottomNav';

/**
 * Shell for guest ('open') events. Intentionally minimal — reuses the shared
 * round pages (RoundSetup, ActiveRound, RoundResults) but presents them under
 * a neutral wordmark and its own Leaderboard/Scoring tab bar instead of the
 * Society header and bottom nav.
 */
export default function ClubhouseLayout({ children }) {
  return (
    <div className="min-h-screen bg-ch-bg flex flex-col">
      <ClubhouseHeader />
      <main className="flex-1 w-full py-4 pb-24">
        <div className="max-w-xl mx-auto">
          {children}
        </div>
      </main>
      <ClubhouseBottomNav />
    </div>
  );
}
